import React from "react";
import PropTypes from "prop-types";
import { MenuItem, TextField } from "@mui/material";

export default function CarrierBondTypeSelectField({
  bondsList,
  value,
  onChange,
  margin = "dense",
  label = "Bond Type",
}) {
  return (
    <TextField
      select
      margin={margin}
      label={label}
      fullWidth
      variant="outlined"
      value={value}
      onChange={onChange}
    >
      {bondsList.map((option) => (
        <MenuItem key={option.bond_type_id} value={option.bond_type_id}>
          {option.type || option.name}
        </MenuItem>
      ))}
    </TextField>
  );
}

CarrierBondTypeSelectField.propTypes = {
  bondsList: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func.isRequired,
  margin: PropTypes.string,
  label: PropTypes.string,
};
